export default __webpack_public_path__ + "static/media/VIPBackground.f4fc7c7d.png";